import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, ElementRef, ChangeDetectorRef } from '@angular/core';

import { phxBadgeDefaultValues } from '../../badge/phx-badge.component';
import { PhxBadgeIntent, PhxBadgeContrast } from '../../badge/phx-badge.types';
import { PhxBreadcrumbItemProps } from '../phx-breadcrumb.types';

import mixinDisabled from '../../../mixins/disabled';
import { isNil } from '../../../utils';

const baseMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  selector: 'phx-breadcrumb-item',
  templateUrl: './phx-breadcrumb-item.component.html',
  styleUrls: ['./phx-breadcrumb-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ['disabled'],
  host: {
    class: 'phx-breadcrumb-item',
    '[class.phx-breadcrumb-item-disabled]': 'disabled',
    '[class.phx-truncate-last-item]': 'isLast && isTruncating'
  },
})
export class PhxBreadcrumbItemComponent extends baseMixin {
  @Input() public phxText: string;
  @Input() public phxLink: string | any[];
  @Input() public phxBadgeText: string;
  @Input() public phxBadgeIntent: PhxBadgeIntent = phxBadgeDefaultValues.intent;
  @Input() public phxBadgeContrast: PhxBadgeContrast = phxBadgeDefaultValues.contrast;

  public isLast: boolean = false;
  public isDefaultSize: boolean = true;
  public isTruncating: boolean = false;
  public nativeElement: Element;

  constructor(elemRef: ElementRef, private _cdr: ChangeDetectorRef) {
    super();
    this.nativeElement = elemRef.nativeElement;
  }

  public get routeLink() {
    return this.disabled ? null : this.phxLink;
  }

  public setBreadcrumbItemProps(props: PhxBreadcrumbItemProps) {
    this.isLast = isNil(props.isLast) ? this.isLast : props.isLast;
    this.isDefaultSize = isNil(props.isDefaultSize) ? this.isDefaultSize : props.isDefaultSize;
    this.isTruncating = isNil(props.isTruncating) ? this.isTruncating : props.isTruncating;

    this._cdr.detectChanges();
  }
}
